import { render, staticRenderFns } from "./EditUserFacilities.vue?vue&type=template&id=34041e2a&scoped=true"
import script from "./EditUserFacilities.vue?vue&type=script&lang=js"
export * from "./EditUserFacilities.vue?vue&type=script&lang=js"
import style0 from "./EditUserFacilities.vue?vue&type=style&index=0&id=34041e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34041e2a",
  null
  
)

export default component.exports